import type { FunctionComponent } from "react"

import { useParams } from "next/navigation"

import HeartError from "@jobteaser/ui-kit/assets/pictograms/jds_pictogram_heart_error.svg"
import { EmptyState } from "@jobteaser/ui-kit/components/EmptyState/EmptyState"

import { useArticlesHasFilter } from "@/modules/companies/client/hooks/useArticlesHasFilter"
import { useCompanyFollowerFetch } from "@/modules/companies/client/hooks/useCompanyFollowerFetch"
import { useFollowCompany } from "@/modules/companies/client/hooks/useFollowCompany"
import { COMPANY_BASENAME, COMPANY_NEWSFEED } from "@/modules/companies/client/utils/routing"
import { useTranslation } from "@/modules/i18n/components/useTranslation"
import { useLocale } from "@/modules/locales/useLocale"
import { Link } from "@/modules/routing/components/Link"

export const ArticlesEmptyStates: FunctionComponent = () => {
  const locale = useLocale()
  const { dataCompanyFollower } = useCompanyFollowerFetch()
  const { followCompany, isLoadingFollowCompany } = useFollowCompany()
  const { t } = useTranslation(["companies_client"])
  const { companySlug } = useParams()
  const hasFilters = useArticlesHasFilter()

  const isFollowingCompany = !!dataCompanyFollower?.userInfo?.followsCompany
  const isAuthorizedToFollow = !!dataCompanyFollower?.userInfo?.authorizedToFollow

  let title = ""
  let description = ""
  let cta = null
  let testId = ""

  if (!hasFilters) {
    title = t("companies_client.newsFeed.articles.emptyStates.title.noArticles")
    description = t("companies_client.newsFeed.articles.emptyStates.description.noArticles")
    testId = "company_articles_empty_states_no_article"

    if (isAuthorizedToFollow && !isFollowingCompany) {
      cta = (
        <EmptyState.Button
          isLoading={isLoadingFollowCompany}
          onClick={() => {
            followCompany(true)
          }}
        >
          {t("companies_client.newsFeed.articles.emptyStates.action.follow")}
        </EmptyState.Button>
      )
    }
  } else {
    title = t("companies_client.newsFeed.articles.emptyStates.title.noFilteredArticles")
    description = t("companies_client.newsFeed.articles.emptyStates.description.noFilteredArticles")
    testId = "company_articles_empty_states_reset_filters"
    cta = (
      <EmptyState.Button
        component={Link}
        href={`/${locale}/${COMPANY_BASENAME}/${companySlug}/${COMPANY_NEWSFEED}`}
        scroll={false}
        shallow
      >
        {t("companies_client.newsFeed.articles.emptyStates.action.resetFilters")}
      </EmptyState.Button>
    )
  }
  return (
    <EmptyState pictogram={HeartError} title={title} description={description} data-testid={testId}>
      {cta}
    </EmptyState>
  )
}
